import TcAndPrivacy from "../../Components/TcAndPrivacy/TcAndPrivacy";

const privacyPolicyData = [
  {
    id: "intro",
    header: "Introduction",
    content: (
      <p>
        This privacy policy for Sustainability Economics (hereinafter referred
        to as “Company”, “We”, “Us”, or “Our“), describes how and why we might
        collect, store, use, and/or share (“Process”) Your information when You
        choose to use our services (“Services“). This Privacy Policy describes
        Our policies and procedures on the collection, use and disclosure of
        Your information when You use the Service and tells You about Your
        privacy rights and how the law protects You. We use Your Personal data
        to provide and improve the Services. By using the Service, You agree to
        the rightful collection and use of information and/or data in accordance
        with this Privacy Policy.
      </p>
    ),
  },
  {
    id: "interpretation-and-definitions",
    header: "Interpretation and Definitions",
    content: (
      <>
        <p>
          <strong>Interpretation:</strong>
        </p>

        <ul>
          <li>
            The words of which the initial letter is capitalised have meanings
            defined under the following conditions unless defined above. The
            following definitions shall have the same meaning regardless of
            whether they appear in singular or in plural.
          </li>
        </ul>

        <br />

        <p>
          <strong>Definitions:</strong>
        </p>

        <p>For the purposes of this Privacy Policy:</p>

        <br />

        <ul>
          <li>
            <b>Account</b> means a unique account created for You to access Our
            Service or parts of Our Service.
          </li>
          <li>
            <b>Affiliate</b> means an entity that controls, is controlled by or
            is under common control with a party, where "control" means
            ownership of 50% or more of the shares, equity interest or other
            securities entitled to vote for election of directors or other
            managing authority.
          </li>
          <li>
            <b>Company</b> (referred to as either "the Company", "We", "Us" or
            "Our" in this Agreement) refers to Sustainability Economics, 328
            North Bridge Rd, #02-20, Raffles Hotel Arcade, 188719, SINGAPORE
          </li>
          <li>
            <b>Cookies</b> are small files that are placed on Your computer,
            mobile device or any other device by a website, containing the
            details of Your browsing history on that website among its many
            uses.
          </li>
          <li>
            <b>Device</b> means any device that can access the Service such as a
            computer, a cell phone or a digital tablet.
          </li>
          <li>
            <b>Personal Data</b> is any information that relates to an
            identified or identifiable individual.
          </li>
          <li>
            <b>Service</b> refers to the Website.
          </li>
          <li>
            <b>Service</b> Provider means any natural or legal person who
            processes the data on behalf of the Company. It refers to
            third-party companies or individuals employed by the Company to
            facilitate the Service, to provide the Service on behalf of the
            Company, to perform services related to the Service or to assist the
            Company in analyzing in what manner the Service is used.
          </li>
          <li>
            <b>Third-party Social Media Service</b> refers to any website or any
            social networking website through which a User can log in or create
            an account to use the Service.  Usage Data refers to data collected
            automatically, either generated by the use of the Service or from
            the Service infrastructure itself (including but not limited to, the
            duration of a page visit).
          </li>
          <li>
            <b>Usage Data</b> refers to data collected automatically, either
            generated by the use of the Service or from the Service
            infrastructure itself (including but not limited to, the duration of
            a page visit).
          </li>
          <li>
            <b>Website</b> refers to Company&apos;s website, accessible from
            <a
              href="https://sustainabilityeconomics.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://sustainabilityeconomics.com/.
            </a>
          </li>
          <li>
            <b>You</b> means the individual accessing or using the Service, or
            the company, or other legal entity on behalf of which such
            individual is accessing or using the Service, as applicable.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "personal-data",
    header: "Collecting and Using Your Personal Data",
    content: (
      <>
        <p>
          <strong>Personal information You disclose to us:</strong>
        </p>

        <ul>
          <li>
            We process Your personal data based on the following legal grounds:
            Your consent, the necessity to perform a contract with You, in
            compliance with a legal obligation(s), protection of Your vital
            interest(s), the performance of a task carried out in the public
            interest, and/or for Our legitimate and legal interest(s). The
            personal information we collect may include but is not limited to
            the following:
          </li>

          <li>Email address</li>
          <li>First name and last name</li>
          <li>Phone number</li>
          <li>Address, State, Province, ZIP/Postal code, City</li>
          <li>Usage Data</li>
        </ul>

        <br />

        <p>
          <strong>Sensitive Information:</strong>
        </p>

        <ul>
          <li>
            We do not process sensitive information which may include
            government-issued identification numbers, financial details such as
            credit card or bank account information, medical or health-related
            data, biometric identifiers like fingerprints or facial recognition
            data, precise geolocation information, or any other data considered
            sensitive under applicable laws. However, only when necessary, with
            Your prior explicit consent or as otherwise permitted by applicable
            law, we process the following categories of sensitive information:
            name, email address, phone number, occupation, address or any other
            data that is considered sensitive under applicable laws. For the
            purpose of this Privacy Policy, necessary circumstances may include
            but are not limited to, complying with legal obligations (e.g., KYC
            or AML requirements), fulfilling specific services like payment
            processing or healthcare, enhancing security measures like biometric
            authentication, addressing legal claims or investigations, or
            protecting vital interests in emergencies.
          </li>
        </ul>

        <br />

        <p>
          <strong>Geolocation Information:</strong>
        </p>

        <ul>
          <li>
            We may request access or permission to track location-based
            information from Your mobile device, either continuously or while
            You are using Our website, to provide certain location-based
            services. If You wish to change Our access or permissions, You may
            do so in Your device&apos;s settings. We collect location data such
            as information about Your device&apos;s location, which can be
            either precise or imprecise. How much information we collect depends
            on the type and settings of the device You use to access the
            Services. For example, we may use GPS and other technologies to
            collect geolocation data that tells us Your current location (based
            on Your IP address). You can opt out of allowing us to collect this
            information either by refusing access to the information or by
            disabling Your Location setting on Your device. However, if You
            choose to opt out, You may not be able to use certain aspects of the
            Services.
          </li>
        </ul>

        <br />

        <p>
          <strong>Device Data:</strong>
        </p>

        <ul>
          <li>
            We collect device data such as information about Your computer,
            phone, tablet, or other device You use to access the Services.
            Depending on the device used, this device data may include
            information such as Your IP address (or proxy server), device and
            application identification numbers, location, browser type, hardware
            model, Internet service provider and/or mobile carrier, operating
            system, and system configuration information.
          </li>
        </ul>

        <br />

        <p>
          <strong>Mobile Device Access:</strong>
        </p>

        <ul>
          <li>
            We may request access or permission to certain features from Your
            mobile device, including Your mobile device&apos;s Bluetooth,
            calendar, camera, own, and other features. If You wish to change Our
            access or permissions, You may do so in Your device&apos;s settings.
            This may limit the type of services.
          </li>
        </ul>

        <br />

        <p>
          <strong>Information automatically collected:</strong>
        </p>

        <ul>
          <li>
            We automatically collect certain information when You visit, use, or
            navigate the Services. This information does not reveal Your
            specific identity (such as Your name or contact information) but may
            include device and usage information, such as Your IP address,
            browser and device characteristics, operating system, language
            preferences, referring URLs, device name, country, location,
            information about how and when You use Our Services, and other
            technical information. This information is primarily needed to
            maintain the security and operation of Our Services, and for Our
            internal analytics and reporting purposes.
          </li>
        </ul>

        <br />

        <p>
          <strong>Log and Usage Data:</strong>
        </p>

        <ul>
          <li>
            Log and usage data is service-related, diagnostic, usage, and
            performance information Our servers automatically collect when You
            access or use Our Services and which we record in log files.
            Depending on how You interact with us, this log data may include
            Your IP address, device information, browser type, and settings and
            information about Your activity in the Services (such as the
            date/time stamps associated with Your usage, pages and files viewed,
            searches, and other actions You take such as which features You
            use), device event information (such as system activity, error
            reports (sometimes called “crash dumps”), and hardware settings).
            This information helps us to better understand our customer
            behaviour, which further helps us to cater to their needs in a more
            efficient manner.
          </li>
        </ul>

        <br />

        <p>
          <strong>Information collected from other sources:</strong>
        </p>

        <ul>
          <li>
            In order to enhance Our ability to provide relevant marketing,
            offers, and services to You and update Our records, we may obtain
            information about You from other sources, which includes but are not
            limited to- public databases, joint marketing partners, affiliate
            programs, data providers, social media platforms, and from other
            third parties. This information includes mailing addresses, job
            titles, email addresses, phone numbers, intent data (or user
            behaviour data), Internet Protocol (IP) addresses, social media
            profiles, social media URLs, and custom profiles, for purposes of
            targeted advertising and event promotion. If You interact with us on
            a social media platform using Your social media account (e.g.,
            Facebook or Twitter), we receive personal information about You such
            as Your name, email address, and gender. Any personal information
            that we collect from Your social media account depends on Your
            social media account&apos;s privacy settings.
          </li>
        </ul>

        <br />

        <p>
          <strong>User Consent and Withdrawal:</strong>
        </p>

        <ul>
          <li>
            You have the right to withdraw Your consent to the processing of
            Your personal data at any time, especially for non-essential
            processing activities such as marketing communications. To withdraw
            Your consent, You can write to us at{" "}
            <a
              href="mailto:contact@sustainabilityeconomics.com"
              target="_blank"
              rel="noreferrer noopener"
            >
              contact@sustainabilityeconomics.com.
            </a>
            Please note that withdrawing consent may affect Your ability to use
            certain features of the Service.
          </li>
        </ul>

        <br />

        <p>
          <strong>Usage Data:</strong>
        </p>

        <ul>
          <li>Usage Data is collected automatically when using the Service.</li>

          <li>
            Usage Data may include information such as Your Device's Internet
            Protocol address (e.g. IP address), browser type, browser version,
            the pages of our Service that You visit, the time and date of Your
            visit, the time spent on those pages, unique device identifiers and
            other diagnostic data.
          </li>

          <li>
            When You access the Service by or through a mobile device, We may
            collect certain information automatically, including, but not
            limited to, the type of mobile device You use, Your mobile device
            unique ID, the IP address of Your mobile device, Your mobile
            operating system, the type of mobile Internet browser You use,
            unique device identifiers and other diagnostic data.
          </li>

          <li>
            We may also collect information that Your browser sends whenever You
            visit our Service or when You access the Service by or through a
            mobile device.
          </li>
        </ul>

        <br />

        <p>
          <strong>Information from Third-Party Social Media Services:</strong>
        </p>

        <ul>
          <li>
            The Company allows You to create an account and log in to use the
            Service through the following Third-party Social Media Services:
          </li>

          <li>Google</li>
          <li>Facebook</li>
          <li>Instagram</li>
          <li>Twitter</li>
          <li>LinkedIn</li>

          <br />
          <br />

          <li>
            If You decide to register through or otherwise grant us access to a
            Third-Party Social Media Service, We may collect Personal data that
            is already associated with Your Third-Party Social Media Service's
            account, such as Your name, Your email address, Your activities or
            Your contact list associated with that account.
          </li>

          <br />
          <br />

          <li>
            You may also have the option of sharing additional information with
            the Company through Your Third-Party Social Media Service's account.
            If You choose to provide such information and Personal Data, during
            registration or otherwise, You are giving the Company permission to
            use, share, and store it in a manner consistent with this Privacy
            Policy.
          </li>

          <br />
          <br />

          <li>
            We carefully select Our third-party service providers and ensure
            they are compliant with relevant privacy laws. We also assess and
            enforce data protection agreements to maintain the integrity and
            security of Your data. In case we engage in cross-border data
            transfers, we ensure that the necessary legal safeguards are in
            place.
          </li>
        </ul>

        <br />

        <p>
          <strong>Tracking Technologies and Cookies:</strong>
        </p>

        <p>
          We use Cookies and similar tracking technologies to track the activity
          on Our Service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyze Our Service. The technologies We use may
          include:
        </p>

        <br />

        <ul>
          <li>
            <b>Cookies or Browser Cookies:</b> A cookie is a small file placed
            on Your Device. You can instruct Your browser to refuse all Cookies
            or to indicate when a Cookie is being sent. However, if You do not
            accept Cookies, You may not be able to use certain aspects of Our
            Service. Unless You have adjusted Your browser setting so that it
            will refuse Cookies, Our Service may use Cookies.
          </li>

          <li>
            <b>Web Beacons:</b> Certain sections of Our Service and Our emails
            may contain small electronic files known as web beacons (also
            referred to as clear gifs, pixel tags, and single pixel gifs) that
            permit the Company, for example, to count users who have visited
            those pages or opened an email and for other related website
            statistics (for example, recording the popularity of a certain
            section and verifying system and server integrity).
          </li>
        </ul>

        <br />

        <p>
          Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
          remain on Your personal computer or mobile device when You go offline,
          while Session Cookies are deleted as soon as You close Your web
          browser. Learn more about cookies on the Free Privacy Policy website
          article.
        </p>

        <br />

        <p>
          We use both Session and Persistent Cookies for the purposes set out
          below:
        </p>

        <br />

        <ul>
          <li>
            <b>Necessary / Essential Cookies:</b>
          </li>
        </ul>

        <br />

        <p>Type: Session Cookies</p>

        <br />

        <p>Administered by: Us</p>

        <br />

        <p>
          Purpose: These Cookies are essential to provide You with services
          available through the Website and to enable You to use some of its
          features. They help to authenticate users and prevent fraudulent use
          of user accounts. Without these Cookies, the services that You have
          asked for cannot be provided, and We only use these Cookies to provide
          You with those services.
        </p>

        <br />

        <ul>
          <li>
            <b>Cookies Policy / Notice Acceptance Cookies:</b>
          </li>
        </ul>

        <br />

        <p>Type: Persistent Cookies</p>

        <br />

        <p>Administered by: Us</p>

        <br />

        <p>
          Purpose: These Cookies identify if users have accepted the use of
          cookies on the Website.
        </p>

        <br />

        <ul>
          <li>
            <b>Functionality Cookies: </b>
          </li>
        </ul>

        <br />

        <p>Type: Persistent Cookies</p>

        <br />

        <p>Administered by: Us</p>

        <br />

        <p>
          Purpose: These Cookies allow us to remember choices You make when You
          use the Website, such as remembering Your login details or language
          preference. The purpose of these Cookies is to provide You with a more
          personal experience and to avoid You having to re-enter Your
          preferences every time You use the Website.
        </p>

        <p>
          You can manage Your consent preferences at any time by accessing Your
          account settings or contacting us directly. We provide clear options
          for You to opt in or out of specific data processing activities. For
          cookie management, You can adjust Your browser settings to refuse or
          accept cookies, and use Our cookie management tool available on Our
          website.
        </p>

        <p>
          For more information about the cookies we use and Your choices
          regarding cookies, please visit Our Cookies Policy or the Cookies
          section of Our Privacy Policy.
        </p>

        <br />

        <p>
          <strong>Use of Your Personal Data</strong>
        </p>

        <p>The Company may use Personal Data for the following purposes:</p>

        <br />

        <ul>
          <li>
            <b>To provide and maintain Our Service</b>, including to monitor the
            usage of Our Service.
          </li>
          <li>
            <b>To manage Your Account:</b> to manage Your registration as a user
            of the Service. The Personal Data You provide can give You access to
            different functionalities of the Service that are available to You
            as a registered user.
          </li>
          <li>
            <b>For the performance of a contract:</b> the development,
            compliance and undertaking of the purchase contract for the
            products, items or services You have purchased or of any other
            contract with Us through the Service.
          </li>
          <li>
            <b>To contact You:</b> To contact You by email, telephone calls,
            SMS, or other equivalent forms of electronic communication, such as
            a mobile application's push notifications regarding updates or
            informative communications related to the functionalities, products
            or contracted services, including the security updates, when
            necessary or reasonable for their implementation.
          </li>
          <li>
            <b>To provide You</b> with news, special offers and general
            information about other goods, services and events which we offer
            that are similar to those that You have already purchased or
            enquired about unless You have opted not to receive such
            information.
          </li>
          <li>
            <b>To manage Your requests:</b> To attend and manage Your requests
            to Us.
          </li>
          <li>
            <b>For business transfers:</b> We may use Your information to
            evaluate or conduct a merger, divestiture, restructuring,
            reorgantzaiion, dissolution, or other sale or transfer of some or
            all of Our assets, whether as a going concern or as part of
            bankruptcy, liquidation, or similar proceeding, in which Personal
            Data held by Us about Our Service users is among the assets
            transferred.
          </li>
          <li>
            <b>For other purposes:</b> We may use Your information for other
            purposes, such as data analysis, identifying usage trends,
            determining the effectiveness of Our promotional campaigns and to
            evaluate and improve Our Service, products, services, marketing
            and/or Your experience.
          </li>
        </ul>

        <br />

        <p>
          We may share Your personal information in the following situations:
        </p>

        <br />

        <ul>
          <li>
            <b>With Service Providers:</b> We may share Your personal
            information with Service Providers to monitor and/or analyse the use
            of Our Service, to contact You.
          </li>
          <li>
            <b>For business transfers:</b> We may share or transfer Your
            personal information in connection with, or during negotiations of,
            any merger, sale of Company assets, financing, and/or acquisition of
            all or a portion of Our business to another company.
          </li>
          <li>
            <b>With Affiliates:</b> We may share Your information with Our
            affiliates, in which case we will require those affiliates to honour
            this Privacy Policy. Affiliates include Our parent company and any
            other subsidiaries, joint venture partners or other companies that
            We control and/or that are under common control with Us.
          </li>
          <li>
            <b>With business partners:</b> We may share Your information with
            Our business partners to offer You certain products, services and/or
            promotions.
          </li>
          <li>
            <b>With other users:</b> when You share personal information or
            otherwise interact in the public areas with other users, such
            information may be viewed by all users and may be publicly
            distributed outside. If You interact with other users or register
            through a Third-Party Social Media Service, Your contacts on the
            Third-Party Social Media Service may see Your name, profile,
            pictures and description of Your activity. Similarly, other users
            will be able to view descriptions of Your activity, communicate with
            You and view Your profile.
          </li>
          <li>
            <b>With Your consent:</b> We may disclose Your personal information
            for any other purpose with Your consent.
          </li>
        </ul>

        <br />

        <p>
          <strong>Retention of Your Personal Data</strong>
        </p>

        <ul>
          <li>
            We retain personal data for as long as necessary to fulfil the
            purposes outlined in this Privacy Policy, unless a longer retention
            period is required and/or permitted by law. For example, we retain
            contact information for as long as You have an active account with
            us, and we keep transaction records for a minimum of 2 years for
            compliance with legal obligations.
          </li>
          <li>
            The Company will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period of
            time, except when this data is used to strengthen the security, to
            improve the functionality of Our Service, and/or We are legally
            obligated to retain this data for longer time periods.
          </li>
        </ul>

        <br />

        <p>
          <strong>Transfer of Your Personal Data</strong>
        </p>

        <ul>
          <li>
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located. It means that this
            information may be transferred to — and maintained on — computers
            located outside of Your state, province, country or other
            governmental jurisdiction where the data protection laws may differ
            than those from Your jurisdiction.
          </li>
          <li>
            When transferring personal data outside of Your jurisdiction, we
            ensure adequate protection is in place, including the use of
            Standard Contractual Clauses (SCCs) or other legally accepted
            mechanisms. These measures ensure that Your data receives the same
            level of protection as it does under applicable local laws.
          </li>
          <li>
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </li>
          <li>
            The Company will take all steps reasonably necessary to ensure that
            Your data is treated securely and in accordance with this Privacy
            Policy and no transfer of Your Personal Data will take place to an
            organisation or a country unless there are adequate controls in
            place including the security of Your data and other personal
            information.
          </li>
        </ul>

        <br />

        <p>
          <strong>Delete Your Personal Data</strong>
        </p>

        <ul>
          <li>
            You have the right to delete or request that We assist in deleting
            the Personal Data that We have collected about You or incidental to
            your use of Our Services. Our Service may give You the ability to
            delete certain information about You from within the Service.
          </li>
          <li>
            Our Service may give You the ability to delete certain information
            about You from within the Service.
          </li>
          <li>
            As a data subject, you have the right to access, rectify, erase, and
            restrict the processing of Your personal data. You also have the
            right to data portability and to object to the processing of Your
            data. If You wish to exercise any of these rights, please contact us
            at{" "}
            <a
              href="mailto:dpo@sustainabilityeconomics.com"
              target="_blank"
              rel="noreferrer noopener"
            >
              dpo@sustainabilityeconomics.com.
            </a>
          </li>
          <li>
            Please note, however, that We may need to retain certain information
            when we have a legal obligation or lawful basis to do so.
          </li>
        </ul>

        <br />
        <p>
          <strong>Your Data Rights</strong>
        </p>

        <ul>
          <li>
            In addition to Your right to delete or correct Your personal data,
            You have the right to:
          </li>

          <li>
            Data Portability: Request a copy of the personal data You have
            provided to us in a structured, commonly used, and machine-readable
            format, and the right to transmit that data to another data
            controller.
          </li>

          <li>
            Object to Processing: Object to the processing of Your personal data
            for specific purposes, including direct marketing, and where
            applicable, we will cease processing unless there are compelling
            legitimate and legal grounds.
          </li>

          <li>
            Restrict Processing: Request that we limit the processing of Your
            personal data in certain circumstances, such as when You contest the
            accuracy of the data or object to processing.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "disclosure-of-personal-data",
    header: "Disclosure of Your Personal Data",
    content: (
      <>
        <p>
          <strong>Business Transactions</strong>
        </p>
        <br />

        <ul>
          <li>
            If the Company is involved in a merger, acquisition or asset sale,
            Your Personal Data may be transferred. We will provide notice before
            Your Personal Data is transferred and becomes subject to a different
            Privacy Policy.
          </li>
        </ul>

        <br />

        <p>
          <strong>Law enforcement</strong>
        </p>

        <ul>
          <li>
            Under certain circumstances, the Company may be required to disclose
            Your Personal Data if required to do so by law or in response to
            valid requests by public authorities (e.g. a court or a government
            agency).
          </li>
        </ul>

        <br />

        <p>
          <strong>Third-Party Service Providers&apos; Data Practices</strong>
        </p>

        <ul>
          <li>
            We ensure that our third-party service providers adhere to the same
            high standards of data privacy and security that we uphold. These
            service providers are contractually bound to only use Your personal
            data for the specific purposes for which they were engaged, and they
            are prohibited from using, disclosing, or retaining Your data for
            any other purpose. We also require that they implement appropriate
            technical and organisational measures to protect Your data.
          </li>
        </ul>

        <br />

        <p>
          <strong>Other legal requirements</strong>
        </p>

        <ul>
          <li>
            The Company may disclose Your Personal Data in the good faith belief
            that such action is necessary to:
          </li>

          <ul>
            <li>Comply with a legal obligation</li>
            <li>Protect and defend the rights or property of the Company</li>
            <li>
              Prevent or investigate possible wrongdoing in connection with the
              Service
            </li>
            <li>
              Protect the personal safety of Users of the Service or the public
            </li>
            <li>Protect against legal liability</li>
          </ul>
        </ul>

        <p>
          <strong>Security of Your Personal Data</strong>
        </p>

        <p>
          We implement industry-standard security measures, including
          encryption, access controls, and regular security audits, to protect
          Your personal data from unauthorized access, disclosure, alteration,
          or destruction. While we strive to use commercially acceptable means
          to protect Your Personal Data, we cannot guarantee its absolute
          security.
        </p>

        <br />

        <p>
          <strong>Data Breach Notification</strong>
        </p>

        <p>
          In the event of a data breach, we will notify You and the relevant
          authorities within 72 hours of becoming aware of the breach, where
          feasible. We will provide You with details of the breach, the
          potential impact, and the measures we have taken or plan to take to
          address the breach. We will also provide You with recommendations on
          how to protect Your personal information moving forward.
        </p>
      </>
    ),
  },
  {
    id: "childrens-privacy",
    header: "Children's Privacy",
    content: (
      <ul>
        <li>
          By using the Services, You represent that You are at least 18 or that
          You are the parent or guardian of such a minor and consent to such
          minor dependent&apos;s use of the Services. If You are a parent or
          guardian and You are aware that Your child has provided Us with
          Personal Data, please contact Us. If We become aware that We have
          collected Personal Data from anyone under the age of 18 without
          verification of parental consent, We take steps to remove that
          information from Our servers. If You become aware of any data we may
          have collected from children under age 18, please contact us at{" "}
          <a
            href="mailto:dpo@sustainabilityeconomics.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            dpo@sustainabilityeconomics.com.
          </a>
        </li>

        <li>
          If We need to rely on consent as a legal basis for processing Your
          information and Your country requires consent from a parent, We may
          require Your parent's consent before We collect and use that
          information.
        </li>
      </ul>
    ),
  },
  {
    id: "links-to-other-websites",
    header: "Links to Other Websites",
    content: (
      <ul>
        <li>
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party's site. We strongly advise You to review the Privacy
          Policy of every site You visit. We have no control over and assume no
          responsibility for the content, privacy policies or practices of any
          third party sites or services.
        </li>
      </ul>
    ),
  },
  {
    id: "privacy-policy-changes",
    header: "Changes to this Privacy Policy",
    content: (
      <ul>
        <li>
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page. We will
          let You know via email and/or a prominent notice on Our Service, prior
          to the change becoming effective and update the "Last updated" date at
          the top of this Privacy Policy. You are advised to review this Privacy
          Policy periodically for any changes. Changes to this Privacy Policy
          are effective when they are posted on this page.
        </li>
      </ul>
    ),
  },
  {
    id: "contact-us",
    header: "Contact Us",
    content: (
      <ul>
        <li>
          For any questions or concerns regarding this Privacy Policy or Your
          data, You can contact our Data Protection Officer at{" "}
          <a
            href="mailto:dpo@sustainabilityeconomics.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            dpo@sustainabilityeconomics.com
          </a>
          . Alternatively, You may reach us through visiting this page on our
          website:{" "}
          <a
            href="https://sustainabilityeconomics.com/contact"
            target="_blank"
            rel="noreferrer noopener"
          >
            https://sustainabilityeconomics.com/contact.
          </a>
        </li>
      </ul>
    ),
  },
];

function PrivacyPolicy() {
  return <TcAndPrivacy title="Privacy Policy" content={privacyPolicyData} />;
}

export default PrivacyPolicy;
